import axios from 'axios';

import { message } from "antd";

const useAxios = (data = {}) => {

  const instance = axios.create({
    baseURL: "http://server.kombosmart.ir:5000" + "/api",
    timeout: 30000, // 30 seconds
    mode: 'no-cors',
    headers: {
      'Access-Control-Allow-Origin': '*',
      "Content-Type": "application/json",
    }  });


  // Add a request interceptor to handle redirects and include data
  instance.interceptors.request.use(
    (config) => {
            
      if (config.loading?.request) {
        const messageConfig = {
          content: config.loading.request,
          key: config.loading.key,
          duration: 0,
        };
        message.loading(messageConfig);
      }

      const token = localStorage.getItem("token");

      if (token) {
        config.headers["x-auth-token"] = `${token}`;
      }

      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );


  // Add a response interceptor to destroy the loading message
  instance.interceptors.response.use(
    (response) => {
      // Check if the response has a 'redirect' object in the data
      if (response.data && response.data.redirect) {
        // Perform the redirect
        window.location.href = response.data.redirect.url;
        return Promise.reject({ redirect: true }); // Return a rejected promise to stop the normal response flow
      } else if (response.data.message || response.config?.loading?.response) {
        message.success(
          response.config?.loading?.response ? response.config.loading.response : response.data.message
        );
      }

      // Destroy the loading message
      const loadingKey = response.config?.loading?.key;
      if (loadingKey) {
          message.destroy(loadingKey);
      }

      return response;
    },
    (error) => {
      console.error(error);
      const errorObj = error.toJSON();
      console.log(errorObj);

      let messageStr = "";

      // If timeout error custmize message
      if (errorObj.code === "ECONNABORTED") {
        messageStr = "Request timed out. Please try again later.";
      } else {
        messageStr = error.response.data?.message
          ? error.response.data.message
          : error.response.data;
      }
      
      // Destroy the loading message
      const loadingKey = errorObj.config?.loading?.key;
      if (loadingKey) {
        message.destroy(loadingKey);
      }

      message.error(messageStr);

      // Check if the error response has a 401 status code
      if (error.response && error.response.status === 401) {
        // Redirect the user to the login page
        window.location.href = "/access-denied";
        return Promise.reject({ redirect: true });
      }
      return Promise.reject(error);
    }
  );

  return {
    get: (url, config) => instance.get(url, { ...config, data }),
    post: (url, data, config) => instance.post(url, data, config),
    put: (url, data, config) => instance.put(url, data, config),
    delete: (url, config) => instance.delete(url, { ...config, data }),
  };
};

export default useAxios;
    